import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Slider from 'react-slick';
import './Carousel.css';
import { getApiBaseUrl, getPublicAssetUrl } from '../../utils/api.js';

const fallbackCarouselImages = [
  '/images/s1.jpg',
  '/images/s2.jpg',
  '/images/s3.jpg',
  '/images/s4.jpg',
];

function Carousel() {
  const [carouselImages, setCarouselImages] = useState(fallbackCarouselImages);
  function getCarouselImageUrl(imagePath) {
    return getPublicAssetUrl(imagePath);
  }

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    variableWidth: false,
    autoplay: true,
    autoplaySpeed: 3000,
  };

  useEffect(() => {
    fetch(`${getApiBaseUrl()}/api/settings/carousel`)
      .then((res) => {
        if (!res.ok) {
          throw new Error('Carousel settings are not available');
        }

        return res.json();
      })
      .then((data) => {
        if (Array.isArray(data.carouselImages) && data.carouselImages.length > 0) {
          setCarouselImages(data.carouselImages);
        }
      })
      .catch((err) => console.error(err));
  }, []);

  return (
    <div className="slider__container">
      <Slider {...settings}>
        {carouselImages.map((image, index) => {
          const slideImage = (
            <img
              src={getCarouselImageUrl(image)}
              alt=""
              className="slider__img"
            />
          );

          return (
            <div key={`${image}-${index}`}>
              {index === 0 ? (
                <Link
                  className="slider__link"
                  to="/game/"
                  aria-label="Перейти к игре СамВДПО"
                >
                  {slideImage}
                </Link>
              ) : slideImage}
            </div>
          );
        })}
      </Slider>
    </div>
  );
}

export default Carousel;
